module.exports = __webpack_public_path__ + "static/crpyto-balancer-3bfab87d2a67774b9a3e43be4952109f.png";